import PropTypes from 'prop-types'

import AtomRadioButton from '@s-ui/react-atom-radio-button'

const FilterItemBasicRadioButton = ({id, isChecked, onChange}) => (
  <AtomRadioButton checked={isChecked} id={id} onChange={onChange} />
)

FilterItemBasicRadioButton.displayName = 'FilterItemBasicRadioButton'
FilterItemBasicRadioButton.propTypes = {
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func
}

export default FilterItemBasicRadioButton
